// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"337":"a0810d1f","549":"704654a1"}[chunkId] + ".chunk.css";
};